import {
  V2ListLanguageFieldsForAccountApiArg,
  useV2ListLanguageFieldsForAccountQuery,
} from "@generated";
import type { LanguageField } from "../types";

export interface UseLanguageFieldsListArgs {
  page?: V2ListLanguageFieldsForAccountApiArg["page"];
  filter?: V2ListLanguageFieldsForAccountApiArg["filter"];
}

export interface LanguageFieldsListPageMeta {
  recordCount: number;
  pageCount: number;
}

export const useLanguageFieldsList = ({
  page,
  filter,
}: UseLanguageFieldsListArgs) => {
  const { data, error, isLoading, isFetching, refetch } =
    useV2ListLanguageFieldsForAccountQuery(
      { page, filter },
      { refetchOnMountOrArgChange: true }
    );

  const rows: LanguageField[] = (data?.data ?? [])
    .map((lf: any) => ({
      id: String(lf.id),
      name: lf.attributes?.name ?? "",
      sowLanguage: lf.attributes?.["sow-language"] ?? "",
      position: lf.attributes?.position ?? 0,
    }))
    // The list query exposes no `sort`, so order by position client-side.
    .sort((a, b) => a.position - b.position);

  const pageMeta: LanguageFieldsListPageMeta = {
    recordCount: data?.meta?.["record-count"] ?? 0,
    pageCount: data?.meta?.["page-count"] ?? 0,
  };

  return { rows, pageMeta, error, isLoading, isFetching, refetch };
};

export default useLanguageFieldsList;
